import requestMaker from '../../lib';
import axios from 'axios';
var CancelToken = axios.CancelToken;

var BATCH_SIZE_MAX = 1;

class FirehoseAdapter {
  constructor() {
    //this.baseURL = '/apps/assessment/proxy/firehose';
    this.baseURL = '/firehose';
    this.endpoint = 'capture';
    this.batch = [];
    this.platform = 'Web';
    this.api = axios.create({
      baseURL: this.baseURL,
    });
  }

  sendEvent(event) {
    if (this.batch.length >= BATCH_SIZE_MAX) {
      this.batch = [];
    }
    if (event) {
      event.category = 'TELEMETRY';
      event.platform = this.platform;
      this.batch.push(event);
    }
    if (this.batch.length >= 1) {
      //sending batch of 1 to server
      this.flush();
    }
  }

  /**
   * Sends any pending events off to firehose
   */
  flush() {
    var _self = this;
    var source = CancelToken.source();
    var postData = JSON.parse(JSON.stringify(this.batch));
    this.batch = [];
    var isCallOk = false;
    const baseQuery = '/proxy/firehose/capture';

    requestMaker(baseQuery, postData)
      .then(function(response) {
        if (response.status !== 204) {
          //Refill the batch, The response is not an expected 204
          _self.batch = _self.batch.concat(postData);
        } else {
          //All good
          isCallOk = true;
        }
      })
      .catch(function() {
        _self.batch = _self.batch.concat(postData);
      });

    setTimeout(() => {
      if (!isCallOk) {
        // if the timeout fires, and our results didn't come back
        // then we'll call the cancel func set by CancelToken
        _self.batch = _self.batch.concat(postData);
        source.cancel();
      }
    }, 3000);
  }

  reportEvent(event) {
    var _self = this;
    return new Promise(function(resolve) {
      try {
        _self.sendEvent(event).bind(_self);
      } catch (err) {
        //Don't really care what happened
      }
      resolve(204);
    });
  }
}

export default new FirehoseAdapter();
